var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Ask',{ref:"ask",attrs:{"canAccept":_vm.name && Boolean(_vm.name.trim())}},[_c('InputText',{staticClass:"mb-2 mt-4",attrs:{"autofocus":"","placeholder":"Saved Search Name","value":_vm.name},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }